
<div *ngFor="let msg of message_log">
  <campl-ngx-message [msgin]="msg"></campl-ngx-message>
</div>



